import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Placeholder from "@/v2-ui/Placeholder"

export type TableEmptyProps = ComponentProps<"div">

/**
 * Empty state placeholder for when the table has no data.
 */
function TableEmpty(props: TableEmptyProps) {
  const { className, children, ...divProps } = props
  return (
    <div className={cn("ui-table-empty", className)} {...divProps}>
      {children ?? <Placeholder>No data found.</Placeholder>}
    </div>
  )
}

export default TableEmpty
